webpackJsonp([35],{

/***/ "/rMf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4C3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("a3Yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_common__ = __webpack_require__("sf/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("meMj");



var state = {
  token: null
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* CHANGE_TOKEN */], function (state, res) {
  state.token = res;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ "5OHe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6if3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "8P6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"double-bounce2"})]),_vm._v(" "),_c('p',[_vm._v("正在拼命加载中.....")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_34b1c3b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("jX61");
function injectStyle (ssrContext) {
  __webpack_require__("VCg2")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_34b1c3b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("Y9Nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("HVJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__http_api_js__ = __webpack_require__("m4jk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_less__ = __webpack_require__("KvBz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__("wSez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css__ = __webpack_require__("5OHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css__);




 //vuex
 //http请求

 //移动端UI

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_5__http_api_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$store = __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */];

// 用钩子函数beforeEach()对路由进行判断
var token = localStorage.getItem('access_token');
if (token) {
  // 更新 Vuex store 中的 token
  __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */].commit("CHANGE_TOKEN", token);
}
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    // 需要权限,进一步进行判断
    if (__WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */].state.login.token) {
      // 通过vuex state获取当前的token是否存在
      next();
    } else {
      //如果没有权限,重定向到登录页,进行登录
      next({
        path: '/login'
        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    //不需要权限 直接跳转
    next();
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "VCg2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("Y9Nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("cigS");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
//按需加载,当渲染其他页面时才加载其组件,并缓存,减少首屏加载时间
var Index = function Index(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mlqX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var wallet = function wallet(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6AAE")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invite = function invite(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VlHH")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var User = function User(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("i/Eh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var charge = function charge(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZI/c")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var applyCard = function applyCard(resolve) {
  return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QjS7")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var payCard = function payCard(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5Ehp")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Pay = function Pay(resolve) {
  return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mZRd")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Quw4")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var equity = function equity(resolve) {
  return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fGxX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var indexRecord = function indexRecord(resolve) {
  return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bo5V")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var exchangeRecord = function exchangeRecord(resolve) {
  return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ebTT")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var inviteDetail = function inviteDetail(resolve) {
  return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Vg/V")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var xieyiList = function xieyiList(resolve) {
  return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nhdp")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var register = function register(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c2lw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var moneyDetail = function moneyDetail(resolve) {
  return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("To5i")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var transfer = function transfer(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ThC4")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bindPhone = function bindPhone(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gf3I")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bindEmail = function bindEmail(resolve) {
  return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Cm2k")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var changePass = function changePass(resolve) {
  return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HUSq")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var forgetPoss = function forgetPoss(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2Y2+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var xieyiDetail = function xieyiDetail(resolve) {
  return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hkLF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var annouCenter = function annouCenter(resolve) {
  return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jllv")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var question = function question(resolve) {
  return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lc06")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var cvv = function cvv(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1VJ5")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var KYCcerty = function KYCcerty(resolve) {
  return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fq3u")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var rechargeCurr = function rechargeCurr(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6str")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var chargeRecord = function chargeRecord(resolve) {
  return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XCep")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var saoyisao = function saoyisao(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("b4M9")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var result = function result(resolve) {
  return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LwJx")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var kefu = function kefu(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fo//")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var recordDetail = function recordDetail(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Phxh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var chongzhiRecord = function chongzhiRecord(resolve) {
  return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vf4T")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var chongzhiDetail = function chongzhiDetail(resolve) {
  return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2ev/")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: '首页',
    component: Index
  }, {
    path: '/wallet',
    name: '钱包',
    component: wallet
  }, {
    path: '/moneyDetail',
    name: '余额明细',
    component: moneyDetail,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/transfer',
    name: '转账',
    component: transfer,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/invite',
    name: '邀请',
    component: invite
  }, {
    path: '/inviteDetail',
    name: '邀请记录',
    component: inviteDetail,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/indexRecord',
    name: '全部记录',
    component: indexRecord,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/exchangeRecord',
    name: '兑换记录',
    component: exchangeRecord,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/cvv',
    name: '安全码',
    component: cvv,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/equity',
    name: '权益',
    component: equity,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/chargeRecord',
    name: '充值明细',
    component: chargeRecord,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/chongzhiRecord',
    name: '充值记录',
    component: chongzhiRecord,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/chongzhiDetail',
    name: '充值详情',
    component: chongzhiDetail,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/user',
    name: '我的',
    component: User
    // meta: {
    //      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录才能进入的
    //  },
  }, {
    path: '/changePass',
    name: '修改密码',
    component: changePass,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录才能进入的
    }
  }, {
    path: '/forgetPoss',
    name: '重置密码',
    component: forgetPoss
  }, {
    path: '/bindPhone',
    name: '手机',
    component: bindPhone,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录才能进入的
    }
  }, {
    path: '/bindEmail',
    name: '邮箱',
    component: bindEmail,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录才能进入的
    }
  }, {
    path: '/charge',
    name: '充值',
    component: charge,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/applyCard',
    name: '申请卡',
    component: applyCard,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/payCard',
    name: '卡付款',
    component: payCard,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/login',
    name: '登录',
    component: Login
  }, {
    path: '/xieyiList',
    name: '协议',
    component: xieyiList
  }, {
    path: '/register',
    name: '注册',
    component: register
  }, {
    path: '/xieyiDetail',
    name: '协议详情',
    component: xieyiDetail
  }, {
    path: '/annouCenter',
    name: '公告中心',
    component: annouCenter
  }, {
    path: '/question',
    name: '常见问题',
    component: question
  }, {
    path: '/KYCcerty',
    name: '认证',
    component: KYCcerty,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/rechargeCurr',
    name: '充币',
    component: rechargeCurr,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/saoyisao',
    name: '扫一扫',
    component: saoyisao,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/result',
    name: '注销确认',
    component: result,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/kefu',
    name: '客服',
    component: kefu
  }, {
    path: '/recordDetail',
    name: '记录详情',
    component: recordDetail
  }]
}));

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("Y9Nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("HVJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_detail__ = __webpack_require__("yW3m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_login__ = __webpack_require__("4C3y");
//store.js



// 头部分类

// import category from './modules/category'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    detail: __WEBPACK_IMPORTED_MODULE_2__modules_detail__["a" /* default */],
    // category,
    login: __WEBPACK_IMPORTED_MODULE_3__modules_login__["a" /* default */]
  }
}));

/***/ }),

/***/ "jX61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('v-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.fetchLoading),expression:"fetchLoading"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m4jk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("BMa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__("wSez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);





var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
api.defaults.baseURL = 'https://cc-card.com';
api.defaults.timeout = 5000;
api.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
api.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';

// 请求拦截
api.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // store.commit('SET_LOADING',true);
  // 如果有token,添加到请求报文 后台会根据该报文返回status
  if (__WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].state.login.token) {
    config.headers.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].state.login.token;
  }

  return config;
}, function (error) {
  // 对请求错误做些什么
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])('网络错误,请稍后再试');

  __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 添加响应拦截器
api.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // 加到时器主要是为了 展示Loading效果 项目中应去除
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);
  }, 300);

  return response;
}, function (error) {
  // 对响应错误做点什么
  __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);
  //     console.log("Error response:", error.response);
  // console.log("Error response data:", error.response.data);
  // console.log("Error status code:", error.response.status);
  if (error.response) {
    if (error.response.status == 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])('请重新登录');
      __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('CHANGE_TOKEN', null);
      localStorage.removeItem('access_token');
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({
        path: 'login',
        query: { redirect: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.fullPath }
      });
    } else {
      var errorMessage = error.response.data;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])(errorMessage);
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ "meMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_COL_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_SIZE_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_CARLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_COUNT; });
/* unused harmony export SET_SELECTEDLIST */
/* unused harmony export SET_UNSELECTEDLIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TOKEN; });
/* unused harmony export CHANGE_TABINDEX */
/* Detail + Car*/

//Detail父组件中 当前页面商品的数据

var SET_DATAS = 'SET_DATAS';

//chose组件选择的颜色
var CHANGE_COL_SELECTED = 'CHANGE_COL_SELECTED';

//chose组件选择的尺寸

var CHANGE_SIZE_SELECTED = 'CHANGE_SIZE_SELECTED';

//footer组件中保存添加的商品的数据

var ADD_PRODUCT = 'ADD_PRODUCT';

//footer组件中保存购物车数量的数据

var CHANGE_COUNT = 'CHANGE_COUNT';

//提交订单后重新设置购物车商品列表,把打钩并提交的商品去掉,即保留unSelectedList
var RESET_CARLIST = 'RESET_CARLIST';

//提交订单后重新设置购物车商品数量
var RESET_COUNT = 'RESET_COUNT';

// 购物车里打钩的商品

var SET_SELECTEDLIST = 'SET_SELECTEDLIST';

//购物车里没打钩的商品

var SET_UNSELECTEDLIST = 'SET_UNSELECTEDLIST';

//全局loading状态

var SET_LOADING = 'SET_LOADING';

// 改变token(权限)
var CHANGE_TOKEN = 'CHANGE_TOKEN';

// 分类页的aside index
var CHANGE_TABINDEX = 'CHANGE_TABINDEX';

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_loading__ = __webpack_require__("y+dn");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'v-loading': __WEBPACK_IMPORTED_MODULE_0__common_loading__["a" /* default */]
  },
  computed: {
    fetchLoading: function fetchLoading() {
      return this.$store.state.detail.fetchLoading;
    }
  }
});

/***/ }),

/***/ "sf/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var STORAGE_USER_KEY = 'STORAGE_USER_KEY';
// const STORAGE_CARTLIST_KEY = 'STORAGE_CARTLIST_KEY'
// const STORAGE_QUERYMYLIST_KEY = 'STORAGE_QUERYMYLIST_KEY'

/* harmony default export */ __webpack_exports__["a"] = ({
  // 获取
  getLocal: function getLocal() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_USER_KEY;

    // console.log('get local operation')
    return JSON.parse(window.localStorage.getItem(key));
  },

  // 设置用
  setLocal: function setLocal(res) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STORAGE_USER_KEY;
    var isSaveOldData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    //第三个参数是true的话,会增加数据而不是重新设置,res必须是数组
    if (isSaveOldData) {
      if (this.getLocal(key)) {
        var oldData = this.getLocal(key);
        return window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldData.concat(res)));
      }
    }
    return window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
  }
});

/***/ }),

/***/ "y+dn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("6if3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d32aa1c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("8P6u");
function injectStyle (ssrContext) {
  __webpack_require__("/rMf")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d32aa1c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d32aa1c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yW3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("a3Yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_common__ = __webpack_require__("sf/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("Y9Nk");


var _mutations;





// 容器
var state = {
  productDatas: '', //detail父组件请求的当前页面商品数据
  colSelected: 0, //0是index,表示第一个
  sizeSelected: 0, //0是index,表示第一个
  count: 0, //购物车里的商品数量
  carList: '', //购物车的商品列表
  fetchLoading: false, //全局加载状态的Loading
  selectedList: '', //已选择的购物车商品列表
  unSelectedList: '' //未选择的购物车商品列表,提交订单后用它替换carList


  //更改 store 中的状态的唯一方法:提交 mutation
  /*
    购物车逻辑:
        unSelectedList：未打钩的购物车商品列表
        SelectedList：已勾选的购物车商品列表
        carList:购物车商品列表
        当支付成功之后,购物车列表需要减掉SelectedList，留下unSelectedList
        直接用unSelectedList替换当前carList即可
  */
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_DATAS */], function (state, res) {
  state.productDatas = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* CHANGE_COL_SELECTED */], function (state, res) {
  state.colSelected = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* CHANGE_SIZE_SELECTED */], function (state, res) {
  state.sizeSelected = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* ADD_PRODUCT */], function (state) {
  state.carList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('carList');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["f" /* CHANGE_COUNT */], function (state) {
  state.count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('count');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["g" /* RESET_CARLIST */], function (state) {
  state.carList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('carList');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["h" /* RESET_COUNT */], function (state) {
  state.count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('carList').length;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["i" /* SET_LOADING */], function (state, res) {
  state.fetchLoading = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SELECTEDLIST', function SET_SELECTEDLIST(state, res) {
  state.selectedList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('selectedList');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_UNSELECTEDLIST', function SET_UNSELECTEDLIST(state) {
  state.unSelectedList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('unSelectedList');
}), _mutations);

var vm = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({});

// action提交mutations，不直接更改状态（通过store.dispatch触发）
var actions = {

  // 父组件发送异步请求
  setDatas: function setDatas(_ref) {
    var commit = _ref.commit;

    vm.$api({
      method: 'post',
      url: "/detail"
    }).then(function (response) {
      commit('SET_DATAS', response.data);
    });
  },


  // 购物车数量增减,true是加,false是减
  setLocalCount: function setLocalCount(_ref2) {
    var commit = _ref2.commit;
    var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('count') || 0;
    if (bool) {
      __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(++count, 'count');
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(--count, 'count');
    }
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["f" /* CHANGE_COUNT */]);
  },


  //网购物车列表添加数据
  addCarList: function addCarList(_ref3, res) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(res, 'carList', true);
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* ADD_PRODUCT */]);
  },


  //重新设置购物车商品列表,把打钩并提交的商品去掉,即保留unSelectedList

  resetCarList: function resetCarList(_ref4) {
    var commit = _ref4.commit,
        getters = _ref4.getters;

    var unSelectedList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('unSelectedList');
    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(unSelectedList, 'carList');
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* RESET_CARLIST */]);
  },

  // 重置购物车数量Count,即没打钩的商品的数量
  resetCount: function resetCount(_ref5) {
    var commit = _ref5.commit,
        getters = _ref5.getters;

    var count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('unSelectedList').length;
    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(count, 'count');
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["h" /* RESET_COUNT */]);
  },


  // 删除购物车列表的某一项 （用新的数组直接替换）
  cutCarList: function cutCarList(_ref6, res) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(res, 'carList');
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* RESET_CARLIST */]);
  },


  // 分别保存打钩的商品和为打钩的商品
  setSelectedList: function setSelectedList(_ref7) {
    var commit = _ref7.commit,
        getters = _ref7.getters;

    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(getters.selectedList, 'selectedList');
    commit('SET_SELECTEDLIST');
    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(getters.unSelectedList, 'unSelectedList');
    commit('SET_UNSELECTEDLIST');
  }
};

// 如同计算属性,处理state的某个状态
var getters = {
  selectedList: function selectedList(state) {
    // choseBool为真的商品 即打钩的商品
    if (state.carList !== '') {
      var arr = state.carList.filter(function (ele) {
        return ele.choseBool == true;
      });
      return arr;
    }
  },
  unSelectedList: function unSelectedList(state) {
    if (state.carList !== '') {
      var arr = state.carList.filter(function (ele) {
        return ele.choseBool == false;
      });
      return arr;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.212c9e223130665444f2.js